<template>
  <v-container class="container">
    <div class="d-flex align-center mb-6">
      <div :class="step !== '가입완료' ? 'active' : 'inactive'">회원가입</div>
      <v-icon>mdi-chevron-right</v-icon>
      <div :class="step === '가입완료' ? 'active' : 'inactive'">가입완료</div>
    </div>

    <UserInfo
      :nextStep="() => handleStepChange(!leadId ? '업체정보' : '선택정보')"
      :step.sync="step"
      :form.sync="form"
      v-if="step === '회원가입'" />
    <StoreInfo
      :prevStep="() => handleStepChange('회원가입')"
      :nextStep="() => handleStepChange('선택정보')"
      :step.sync="step"
      :form.sync="form"
      v-if="step === '업체정보'" />
    <OptionalInfo
      :nextStep="() => handleStepChange('가입완료')"
      :step.sync="step"
      :form.sync="form"
      v-if="step === '선택정보'" />
    <RegisterDone :step.sync="step" :form.sync="form" v-if="step === '가입완료'" />
  </v-container>
</template>

<script>
import userMixin from '@/components/shared/userMixin';
import UserInfo from '@/components/company/signup/UserInfo.vue';
import StoreInfo from '@/components/company/signup/StoreInfo.vue';
import OptionalInfo from '@/components/company/signup/OptionalInfo.vue';
import RegisterDone from '@/components/company/signup/RegisterDone.vue';
import axios from 'axios';

export default {
  name: 'MembersSignup',
  mixins: [userMixin],
  components: {
    UserInfo,
    StoreInfo,
    OptionalInfo,
    RegisterDone,
  },
  data() {
    return {
      step: '회원가입',
      form: {
        email: '',
        password: '',
        password_confirmed: '',
        name: this.$route.query.companyName || '',
        x: this.$route.query.x || '',
        y: this.$route.query.y || '',
        type: 'STORE',
        contact: '',
        isPrivacyAgreed: false,
        isMarketingAgreed: false,
        route: 'None',
        recommended: this.$route.query.recommended || '',
      },

      showPassword: false,
    };
  },

  computed: {
    leadId() {
      const queryParams = this.$route.query;

      if (queryParams.leadId) {
        return queryParams.leadId;
      }

      return null;
    },
  },
  methods: {
    handleStepChange(newStep) {
      window.scrollTo(0, 0);
      this.step = newStep;
    },
    onSubmit() {
      this.$validator
        .validateAll()
        .then(success => {
          if (!success) {
            return;
          }
          if (this.userIsAuthenticated) {
            this.$store.dispatch('logout');
            return null;
            // return this.$store.dispatch('signCompanyUp', {...this.form, email: this.user.email})
          } else {
            return this.$store.dispatch('logout').then(() => {
              return this.$store.dispatch('signUserUp', this.form).then(() => {
                // return this.$store.dispatch('signCompanyUp', {...this.form, step: 0})
              });
            });
          }
        })
        .then(() => {
          if (this.errors.any()) {
            this.$store.commit('setMsg', this.errors.all()[0]);
            this.$store.commit('setShowSnackbar', true);
          } else if (this.$store.getters.error) {
            axios.post('https://hooks.slack.com/services/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', {
              text: '회원가입 중 오류 발생: ' + JSON.stringify(this.$store.getters.error),
            });
            this.$store.commit('setMsg', this.$store.getters.error.message || this.$store.getters.error);
            this.$store.commit('setShowSnackbar', true);
          } else {
            if (this.isMatching()) {
              this.axios
                .put('/company/user', {
                  id: this.user.id,
                  last_login_matching: new Date(),
                })
                .then(() => {
                  this.$router.push('/campaign/search');
                });
            } else {
              this.axios
                .put('/company/user', {
                  id: this.user.id,
                  last_login: new Date(),
                })
                .then(() => {
                  this.$router.push('/company/report');
                });
            }
          }
        });
    },
  },
  created() {
    if (this.userIsAuthenticated) {
      this.$router.push('/company/report');
    }
  },
};
</script>

<style scoped lang="scss">
@import '../../assets/scss/form.scss';
@import '../../assets/scss/custom';

.container {
  width: 375px;
  padding: 24px;
}

.active {
  color: var(--primary_light, #ea2a3a);
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.inactive {
  color: #9b9b9b;

  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
</style>
